export default Object.freeze({
    HOME: 'home',
    AUTO: 'auto',
    CONDO: 'condo',
    TENANT: 'tenant',
    LEAD_FORM: 'lead-form',
    LIFE: 'life',
    MOTO: 'moto',
});
